
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("b8EMT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $31fc0b63559b10c1$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $leG06 = parcelRequire("leG06");

var $k8MAo = parcelRequire("k8MAo");

var $7Clnv = parcelRequire("7Clnv");

var $gKURT = parcelRequire("gKURT");

var $gs2u7 = parcelRequire("gs2u7");

var $9b70D = parcelRequire("9b70D");

var $2aGBJ = parcelRequire("2aGBJ");

var $4rBM8 = parcelRequire("4rBM8");

var $gx7I6 = parcelRequire("gx7I6");

var $4tmE5 = parcelRequire("4tmE5");

var $k3QGO = parcelRequire("k3QGO");

var $68WXR = parcelRequire("68WXR");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");

var $4Nxm2 = parcelRequire("4Nxm2");

var $6xwQE = parcelRequire("6xwQE");

var $h6Rwg = parcelRequire("h6Rwg");

var $6KORI = parcelRequire("6KORI");

var $7D2jm = parcelRequire("7D2jm");
const $31fc0b63559b10c1$var$LoginPage = ()=>{
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { oidcContext: oidcContext } = state || {};
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { isPasswordlessAllowed: isPasswordlessAllowed, checkUsername: checkUsername, isUsernameChecked: isUsernameChecked, checkUsernameError: checkUsernameError, error: loginError, redirectType: redirectType, isRestrictedEmail: isRestrictedEmail, isCheckUsernameLoading: isCheckUsernameLoading, resetLogin: resetLogin, infoCode: infoCode, rememberMeEnabled: rememberMeEnabled, isRememberMeChecked: isRememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox } = (0, $4Nxm2.useLogin)();
    const { isLoading: isLoading, onLogin: handleLogIn, onPasswordlessLogin: handlePasswordlessLogIn } = (0, $6xwQE.useLoginSubmission)();
    const { onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin, onMicrosoftLogin: onMicrosoftLogin, onGoogleSocialLogin: onGoogleSocialLogin, onDismissGoogleOneTap: onDismissGoogleOneTap, socialLoginEligibility: socialLoginEligibility, envSupportsSocialLogin: envSupportsSocialLogin, isSocialBlocked: isSocialBlocked } = (0, $h6Rwg.useSocialLogin)();
    const cobrandingApplication = (0, $NAfW5.useCobrandingApplication)();
    const { isMobileApp: isMobileApp, isEmbedded: isEmbedded, screenSize: screenSize } = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const isLoginSecondStep = isUsernameChecked;
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const emailFromSearchParams = (0, $NAfW5.useEmailFromSearchParams)();
    const [email, setEmail] = (0, $91i6m.useState)(()=>emailFromSearchParams || "");
    (0, $6KORI.useGoogleOneTap)({
        email: email
    });
    const { highlightedSocialProvider: highlightedSocialProvider = null, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly = null } = socialLoginEligibility || {};
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && envSupportsSocialLogin;
    const handleGoogleSocialLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onGoogleSocialLogin(email);
    }, [
        email,
        onGoogleSocialLogin,
        envSupportsSocialLogin
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onMicrosoftLogin(email);
    }, [
        email,
        onMicrosoftLogin,
        envSupportsSocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onAppleLogin(email);
    }, [
        email,
        onAppleLogin,
        envSupportsSocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin) onSlackLogin(email);
    }, [
        email,
        onSlackLogin,
        envSupportsSocialLogin
    ]);
    const handleValidationError = (0, $91i6m.useCallback)((errors)=>dispatch((0, $k8MAo.showFormErrors)(errors)), [
        dispatch
    ]);
    const handleContinue = (email)=>{
        checkUsername(email);
    };
    const handleFormClick = (0, $91i6m.useCallback)(()=>{
        if (envSupportsSocialLogin && screenSize === "mobile") onDismissGoogleOneTap();
    }, [
        onDismissGoogleOneTap,
        screenSize,
        envSupportsSocialLogin
    ]);
    const handleEmailChange = (0, $91i6m.useCallback)((email)=>{
        setEmail(email);
    }, []);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8KhCJ.default), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)("title", {
                    children: formatMessage((0, $9b70D.LoginPageMessages).headTitle)
                })
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gs2u7.default), {
                pageId: (0, $1UkGo.pageId),
                header: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4tmE5.default), {
                    highlightedSocialProvider: highlightedSocialProvider,
                    showSocialLoginOnly: showSocialLoginOnly
                }),
                footer: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gx7I6.default), {
                    oidcContext: oidcContext,
                    isEmbedded: isEmbedded
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $68WXR.default), {
                    showSocialLoginOnly: showSocialLoginOnly,
                    isMobileApp: isMobileApp,
                    oidcContext: oidcContext
                }),
                children: showSocialLoginOnly ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gKURT.default), {
                    email: email,
                    highlightedSocialProvider: highlightedSocialProvider,
                    handleGoogleLogin: handleGoogleSocialLogin,
                    handleMicrosoftLogin: handleMicrosoftLogin,
                    handleAppleLogin: handleAppleLogin,
                    handleSlackLogin: handleSlackLogin
                }) : /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7Clnv.default), {
                            application: cobrandingApplication || null,
                            redirectType: !isLoginSecondStep ? redirectType : null,
                            isRedirecting: redirectType !== null,
                            isSecondStep: isLoginSecondStep,
                            isPasswordlessAllowed: isPasswordlessAllowed,
                            isLoading: isLoading,
                            isCheckUsernameLoading: isCheckUsernameLoading,
                            onContinue: handleContinue,
                            onLogIn: handleLogIn,
                            onPasswordlessLogIn: handlePasswordlessLogIn,
                            error: loginError,
                            info: infoCode,
                            fieldErrors: {
                                email: checkUsernameError
                            },
                            email: email,
                            onValidationError: handleValidationError,
                            onEditEmail: resetLogin,
                            onFormClick: handleFormClick,
                            restrictedEmail: isRestrictedEmail,
                            pageId: (0, $1UkGo.pageId),
                            onEmailChange: handleEmailChange,
                            showRememberMeCheckbox: rememberMeEnabled,
                            rememberMeChecked: isRememberMeChecked,
                            onToggleRememberMeCheckbox: onToggleRememberMeCheckbox
                        }),
                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $k3QGO.default), {
                            isEmbedded: isEmbedded,
                            envSupportsSocialLogin: envSupportsSocialLogin,
                            isSocialBlocked: isSocialBlocked,
                            onSlackLogin: handleSlackLogin,
                            onAppleLogin: handleAppleLogin,
                            onMicrosoftLogin: handleMicrosoftLogin,
                            onGoogleLogin: handleGoogleSocialLogin
                        })
                    ]
                })
            })
        ]
    });
};
function $31fc0b63559b10c1$var$LoginRoute() {
    const { shouldShowRememberedAccounts: shouldShowRememberedAccounts } = (0, $4Nxm2.useLogin)();
    if (shouldShowRememberedAccounts) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7D2jm.default), {});
    return /*#__PURE__*/ (0, $4ZSso.jsx)($31fc0b63559b10c1$var$LoginPage, {});
}
var $31fc0b63559b10c1$export$2e2bcd8739ae039 = $31fc0b63559b10c1$var$LoginRoute;

});
parcelRegister("7Clnv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2307c23eea04d7f$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9OWP7 = parcelRequire("9OWP7");

var $fqDmW = parcelRequire("fqDmW");

var $bt1Sd = parcelRequire("bt1Sd");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $dmC2D = parcelRequire("dmC2D");

var $9w0eB = parcelRequire("9w0eB");

var $lkawQ = parcelRequire("lkawQ");

var $cLysE = parcelRequire("cLysE");

var $31nHY = parcelRequire("31nHY");

var $lnbpL = parcelRequire("lnbpL");

var $j7UeI = parcelRequire("j7UeI");

var $jthWj = parcelRequire("jthWj");

var $gtKO2 = parcelRequire("gtKO2");

var $fYxRW = parcelRequire("fYxRW");

var $1V2cH = parcelRequire("1V2cH");

var $1UkGo = parcelRequire("1UkGo");

var $cZAbO = parcelRequire("cZAbO");

var $6eNI5 = parcelRequire("6eNI5");

var $cs6gC = parcelRequire("cs6gC");

var $brCu8 = parcelRequire("brCu8");

var $83IjZ = parcelRequire("83IjZ");

var $1a5r2 = parcelRequire("1a5r2");

var $9X0U9 = parcelRequire("9X0U9");
var $c32T7 = parcelRequire("c32T7");

var $9MKJ7 = parcelRequire("9MKJ7");
let $a2307c23eea04d7f$var$_ = (t)=>t, $a2307c23eea04d7f$var$t, $a2307c23eea04d7f$var$t1, $a2307c23eea04d7f$var$t2;
const $a2307c23eea04d7f$export$d55ce944e082b58f = (0, $fqDmW.default).div($a2307c23eea04d7f$var$t || ($a2307c23eea04d7f$var$t = $a2307c23eea04d7f$var$_`
  align-items: center;
  color: ${0};
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 8px;
`), (0, $kLNLK).N90);
const $a2307c23eea04d7f$export$a7fed597f4b8afd8 = (0, $fqDmW.default).form($a2307c23eea04d7f$var$t1 || ($a2307c23eea04d7f$var$t1 = $a2307c23eea04d7f$var$_`
  margin: 0;
`));
const $a2307c23eea04d7f$var$InputsWrapper = (0, $fqDmW.default).div($a2307c23eea04d7f$var$t2 || ($a2307c23eea04d7f$var$t2 = $a2307c23eea04d7f$var$_`
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)());
const $a2307c23eea04d7f$export$1f58f750f20f344b = ({ application: application, email: email, error: error, fieldErrors: fieldErrors, info: info, isLoading: isLoading, isPasswordlessAllowed: isPasswordlessAllowed, isRedirecting: isRedirecting, isSecondStep: isSecondStep, isCheckUsernameLoading: isCheckUsernameLoading, onContinue: onContinue, onEditEmail: onEditEmail, onEmailChange: onEmailChange, onFormClick: onFormClick, onLogIn: onLogIn, onPasswordlessLogIn: onPasswordlessLogIn, onValidationError: onValidationError, pageId: pageId, redirectType: redirectType, restrictedEmail: restrictedEmail, showRememberMeCheckbox: showRememberMeCheckbox, rememberMeChecked: rememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox })=>{
    const intl = (0, $leG06.default)();
    const translatedEmailFieldError = (0, $brCu8.useTranslateFormErrorIfAvailable)(fieldErrors.email);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const [password, setPassword] = (0, $91i6m.useState)("");
    const [buttonClicked, setButtonClicked] = (0, $91i6m.useState)("submit");
    const inputRef = (0, $91i6m.useRef)(null);
    const [passwordFieldError, setPasswordFieldError] = (0, $91i6m.useState)(null);
    const onEmailClick = (0, $91i6m.useCallback)(()=>{
        setPassword("");
        setPasswordFieldError(null);
        onEditEmail();
    }, [
        onEditEmail
    ]);
    const { captchaValue: captchaValue, isRequired: isTooManyAttemptsRecaptchaRequired } = (0, $6eNI5.useLoginTooManyAttemptsRecaptchaContext)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const trimmedEmail = email.trim();
        const emailEmpty = trimmedEmail === "";
        const passwordEmpty = password === "";
        // Ignore submission of form while the app is loading.
        if (isLoading) return;
        if (emailEmpty) {
            var _inputRef_current;
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            const emailValidationError = formatMessage((0, $jthWj.default).emailEmpty);
            analyticsClient.errorShownEvent((0, $1UkGo.pageId), "validationError");
            onValidationError({
                email: emailValidationError
            });
        }
        setButtonClicked("submit");
        if (!isSecondStep) {
            analyticsClient.buttonClickedEvent(pageId, "continueToLogin");
            if (!emailEmpty) onContinue(trimmedEmail);
        } else {
            analyticsClient.buttonClickedEvent(pageId, "login");
            if (passwordEmpty) setPasswordFieldError(formatMessage((0, $jthWj.default).passwordEmpty));
            else if (!emailEmpty) onLogIn(trimmedEmail, password);
        }
    };
    const handlePasswordlessButtonClick = async ()=>{
        const trimmedEmail = email.trim();
        if (isLoading || !trimmedEmail) return;
        setButtonClicked("passwordless");
        onPasswordlessLogIn(trimmedEmail);
    };
    const handlePasswordChange = (0, $91i6m.useCallback)((e)=>{
        if (passwordFieldError) setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    }, [
        passwordFieldError,
        setPasswordFieldError,
        setPassword
    ]);
    const buttonContent = ()=>{
        if (!isSecondStep) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "login.form.continue",
            defaultMessage: "Continue"
        });
        if (isPasswordlessAllowed) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "common.login.with.password",
            defaultMessage: "Log in with password"
        });
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "common.login",
            defaultMessage: "Log in"
        });
    };
    const infoContent = ()=>{
        const { formatMessage: formatMessage } = intl;
        const applicationName = application ? (0, $fYxRW.applications)[application].name : "Product";
        const testId = "login-info-test-id";
        if (info) switch(info.code){
            case "migratingExistingUser":
                {
                    const summary = formatMessage((0, $jthWj.default).migrateAccountInfo, {
                        application: applicationName
                    });
                    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            case "existingUserSignupAttempt":
                {
                    const summary = formatMessage((0, $jthWj.default).existingUserSignupAttemptInfo);
                    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            default:
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                    id: "login-info",
                    "data-testid": testId,
                    isHidden: true,
                    children: " "
                });
        }
    };
    (0, $91i6m.useEffect)(()=>{
        analyticsClient.stopInitialLoadApdexEvent("viewLoginPage");
    }, [
        analyticsClient
    ]);
    const emailError = ()=>{
        switch(fieldErrors.email){
            case "unknown":
                return intl.formatMessage((0, $jthWj.default).unexpectedErrorHappened);
            case "rate_limit_exceeded_message":
                return intl.formatMessage((0, $jthWj.default).rateLimitErrorMessage);
            default:
                return translatedEmailFieldError;
        }
    };
    const renderExperimentButtons = ()=>{
        if (redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso) return /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$export$d55ce944e082b58f, {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "login.form.opening.sso",
                    defaultMessage: "Opening your single sign-on provider"
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {})
            ]
        });
        else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
            appearance: "primary",
            id: "login-submit",
            type: "submit",
            isFullWidth: true,
            isDisabled: isSecondStep && isTooManyAttemptsRecaptchaRequired && !captchaValue,
            isLoading: buttonClicked === "submit" && (!!isRedirecting || isLoading || isCheckUsernameLoading),
            children: buttonContent()
        });
    };
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        children: [
            error && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.default), {
                children: error === null || error === void 0 ? void 0 : error.message
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)("span", {
                children: [
                    " ",
                    infoContent(),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$export$a7fed597f4b8afd8, {
                id: "form-login",
                "data-testid": "form-login",
                onSubmit: handleSubmit,
                onClick: onFormClick,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$var$InputsWrapper, {
                        children: [
                            restrictedEmail || redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lkawQ.default), {
                                value: email
                            }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $dmC2D.default), {
                                isReadOnly: isSecondStep || isLoading,
                                fieldError: emailError(),
                                onChange: onEmailChange,
                                value: email,
                                onEmailClick: onEmailClick,
                                placeholderOverride: formatMessage((0, $jthWj.default).emailPlaceholder),
                                inputRef: inputRef
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9w0eB.default), {
                                isHidden: !isSecondStep,
                                fieldError: passwordFieldError || undefined,
                                onChange: handlePasswordChange,
                                value: password,
                                className: `field-group password-field ${isSecondStep ? "expanded" : "hidden"}`
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cZAbO.LoginRecaptcha), {}),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cs6gC.LoginMarketingConsent), {}),
                            showRememberMeCheckbox && redirectType !== (0, $gtKO2.CheckUserNameRedirectType).Sso && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9X0U9.default), {
                                paddingBlockStart: "space.100",
                                paddingBlockEnd: "space.100",
                                children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $c32T7.default), {
                                    direction: "row",
                                    gap: "space.100",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $83IjZ.default), {
                                            testId: "remember-me-checkbox",
                                            isChecked: rememberMeChecked,
                                            onClick: onToggleRememberMeCheckbox,
                                            name: "remember",
                                            label: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $jthWj.default).rememberMeCheckboxLabel)),
                                            // During the redirect process (and while loading), we want to disable the checkbox so that the user doesn't interact with the checkbox.
                                            isDisabled: buttonClicked === "submit" && (!!isRedirecting || isLoading || isCheckUsernameLoading)
                                        }),
                                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9MKJ7.default), {
                                            position: "right",
                                            content: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $jthWj.default).rememberMeTooltip)),
                                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $c32T7.default), {
                                                alignItems: "center",
                                                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1a5r2))), {
                                                    label: formatMessage((0, $jthWj.default).rememberMeTooltip),
                                                    size: "small"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    renderExperimentButtons(),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
                        isHidden: !isSecondStep || !isPasswordlessAllowed,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.StyledSocialLoginButton), {
                            id: "passwordless-button",
                            iconBefore: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bt1Sd))), {
                                label: "email"
                            }),
                            iconAfter: /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
                                style: {
                                    width: 24
                                }
                            }),
                            isFullWidth: true,
                            advisoryEnabled: false,
                            onClick: handlePasswordlessButtonClick,
                            isLoading: buttonClicked === "passwordless" && (!!isRedirecting || isLoading),
                            isDisabled: isTooManyAttemptsRecaptchaRequired && !captchaValue || isLoading || isRedirecting,
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                id: "login.form.passwordless.button",
                                defaultMessage: "Log in with email"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $a2307c23eea04d7f$export$2e2bcd8739ae039 = $a2307c23eea04d7f$export$1f58f750f20f344b;

});
parcelRegister("bt1Sd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8593db29877e5ae9$var$_react = $8593db29877e5ae9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $8593db29877e5ae9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8593db29877e5ae9$var$EmailIcon = (props)=>/*#__PURE__*/ $8593db29877e5ae9$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 7v10h14V7H5zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h14z" fill-rule="nonzero"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 004.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.119 1.119 0 01-1.583 0L5.498 6.5z"/></g></svg>`
    }, props));
$8593db29877e5ae9$var$EmailIcon.displayName = "EmailIcon";
var $8593db29877e5ae9$var$_default = $8593db29877e5ae9$var$EmailIcon;
module.exports.default = $8593db29877e5ae9$var$_default;

});

parcelRegister("gFwNN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1439af55d1343b8c$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");
let $1439af55d1343b8c$var$_ = (t)=>t, $1439af55d1343b8c$var$t;
const $1439af55d1343b8c$var$FieldGroupStyled = (0, $fqDmW.default).div($1439af55d1343b8c$var$t || ($1439af55d1343b8c$var$t = $1439af55d1343b8c$var$_`
  margin-top: ${0}px;
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-top, opacity, transform;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;

  /* Offset @atlaskit/form/Field margin-top */
  &:first-of-type {
    margin-top: ${0}px;
  }

  &.hidden {
    height: 0;
    margin-top: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    overflow: hidden;
  }
`), (0, $6e88g.gridSize)(), -(0, $6e88g.gridSize)());
function $1439af55d1343b8c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $4ZSso.jsx)($1439af55d1343b8c$var$FieldGroupStyled, (0, $b2I6k._)((0, $1Fos3._)({}, props), {
        className: `${props.className ? props.className : ""} ${props.isHidden ? "hidden" : ""}`
    }));
}

});

parcelRegister("dmC2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a37bcfc7af5918f1$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $aiPk3 = parcelRequire("aiPk3");

var $h89s9 = parcelRequire("h89s9");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $8tnYQ = parcelRequire("8tnYQ");

var $26Riy = parcelRequire("26Riy");

var $gaHKK = parcelRequire("gaHKK");

var $leG06 = parcelRequire("leG06");

var $0wXBc = parcelRequire("0wXBc");
let $a37bcfc7af5918f1$var$_ = (t)=>t, $a37bcfc7af5918f1$var$t, $a37bcfc7af5918f1$var$t1, $a37bcfc7af5918f1$var$t2, $a37bcfc7af5918f1$var$t3;
// Offset FieldGroup negative margin by adding a top margin here.
const $a37bcfc7af5918f1$var$ReadOnlyEmail = (0, $fqDmW.default).div($a37bcfc7af5918f1$var$t1 || ($a37bcfc7af5918f1$var$t1 = $a37bcfc7af5918f1$var$_`
  margin-top: ${0}px;
  border: 1px solid rgba(255, 255, 255, 0);
  border-radius: 5px;
  box-sizing: border-box;
  cursor: pointer;
  height: 39px;
  outline: none;
  padding: 9px 32px 9px 8px;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:hover {
    background: ${0};
    border-color: ${0};
  }
  &:focus {
    border-color: ${0};
    border-width: 2px;
    padding: 8px 31px 8px 7px;
  }

  ${0}
`), (0, $6e88g.gridSize)(), (0, $kLNLK).N10, (0, $kLNLK).N20, (0, $kLNLK).B100, (0, $26Riy.media).handheld($a37bcfc7af5918f1$var$t || ($a37bcfc7af5918f1$var$t = $a37bcfc7af5918f1$var$_`
    font-size: 16px;
  `)));
const $a37bcfc7af5918f1$var$ReadOnlyEmailText = (0, $fqDmW.default).span($a37bcfc7af5918f1$var$t2 || ($a37bcfc7af5918f1$var$t2 = $a37bcfc7af5918f1$var$_`
  display: flex;
  overflow: hidden;
  white-space: nowrap;
`));
const $a37bcfc7af5918f1$var$StyledFieldIconContainer = (0, $fqDmW.default)((0, $8tnYQ.default))($a37bcfc7af5918f1$var$t3 || ($a37bcfc7af5918f1$var$t3 = $a37bcfc7af5918f1$var$_`
  float: right;
  margin-top: -22px;
  margin-right: -27px;
`));
const $a37bcfc7af5918f1$var$EmailContainer = ({ fieldError: fieldError, isReadOnly: isReadOnly, onChange: onChange, onEmailClick: onEmailClick, placeholderOverride: placeholderOverride, value: value, inputRef: inputRef })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const prevIsReadOnly = (0, $0wXBc.usePrevious)(isReadOnly);
    (0, $91i6m.useEffect)(()=>{
        var _inputRef_current;
        if (!isReadOnly && prevIsReadOnly) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        isReadOnly,
        prevIsReadOnly,
        inputRef
    ]);
    const handleChange = (e)=>{
        const newValue = e.currentTarget.value;
        onChange(newValue);
    };
    const handleReadOnlyKeyDown = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            onEmailClick();
        }
    };
    const placeholder = placeholderOverride || formatMessage((0, $gaHKK.default).loginFormUsernamePlaceholder);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
        children: isReadOnly ? /*#__PURE__*/ (0, $4ZSso.jsxs)($a37bcfc7af5918f1$var$ReadOnlyEmail, {
            onClick: onEmailClick,
            tabIndex: 0,
            onKeyDown: handleReadOnlyKeyDown,
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)($a37bcfc7af5918f1$var$ReadOnlyEmailText, {
                    children: value
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)($a37bcfc7af5918f1$var$StyledFieldIconContainer, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aiPk3))), {
                        label: ""
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
            id: "username",
            testId: "username" // used in pollinators
            ,
            name: "username",
            autoComplete: "username",
            type: "email",
            placeholder: placeholder,
            label: formatMessage((0, $gaHKK.default).loginFormUsernameLabel),
            autoFocus: !isReadOnly,
            isLabelHidden: true,
            onChange: handleChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldError,
            value: value,
            ref: inputRef
        })
    });
};
var $a37bcfc7af5918f1$export$2e2bcd8739ae039 = $a37bcfc7af5918f1$var$EmailContainer;

});
parcelRegister("aiPk3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7803655e4c5390ba$var$_react = $7803655e4c5390ba$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $7803655e4c5390ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7803655e4c5390ba$var$EditFilledIcon = (props)=>/*#__PURE__*/ $7803655e4c5390ba$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.02 19.23a1 1 0 001.18 1.18l3.81-.78-4.21-4.21-.78 3.81zM19.844 6.707l-2.12-2.122A1.997 1.997 0 0016.308 4c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 000-2.828z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7803655e4c5390ba$var$EditFilledIcon.displayName = "EditFilledIcon";
var $7803655e4c5390ba$var$_default = $7803655e4c5390ba$var$EditFilledIcon;
module.exports.default = $7803655e4c5390ba$var$_default;

});

parcelRegister("h89s9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $666bf2328d96f7b9$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $7ecAu = parcelRequire("7ecAu");

var $9yEtj = parcelRequire("9yEtj");
var $iO71n = parcelRequire("iO71n");
const $666bf2328d96f7b9$var$FormTextField = (_param, ref)=>{
    var { name: name, label: label, isLabelHidden: isLabelHidden, invalidMessage: invalidMessage, testId: testId, isRequired: isRequired } = _param, props = (0, $6NU0v._)(_param, [
        "name",
        "label",
        "isLabelHidden",
        "invalidMessage",
        "testId",
        "isRequired"
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $iO71n.default), {
        name: name,
        label: !isLabelHidden && label,
        isRequired: isRequired,
        "aria-required": isRequired,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $4ZSso.jsxs)((0, $91i6m.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7ecAu.default), (0, $b2I6k._)((0, $1Fos3._)({}, fieldProps, props), {
                        testId: testId,
                        ref: ref
                    })),
                    invalidMessage && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9yEtj.ErrorMessage), {
                        children: invalidMessage
                    })
                ]
            })
    });
};
var $666bf2328d96f7b9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef($666bf2328d96f7b9$var$FormTextField);

});
parcelRegister("7ecAu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54339ad51eb86f63$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $61RDg = parcelRequire("61RDg");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $koa2c = parcelRequire("koa2c");

var $4ucu0 = parcelRequire("4ucu0");
var $54339ad51eb86f63$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $54339ad51eb86f63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54339ad51eb86f63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54339ad51eb86f63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54339ad51eb86f63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $54339ad51eb86f63$var$analyticsParams = {
    componentName: "textField",
    packageName: "@atlaskit/textfield",
    packageVersion: "6.4.2"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ var $54339ad51eb86f63$var$Textfield = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $54339ad51eb86f63$var$_excluded);
    var inputRef = (0, $91i6m.useRef)(null);
    var handleOnFocus = (0, $koa2c.usePlatformLeafEventHandler)($54339ad51eb86f63$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $54339ad51eb86f63$var$analyticsParams));
    var handleOnBlur = (0, $koa2c.usePlatformLeafEventHandler)($54339ad51eb86f63$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $54339ad51eb86f63$var$analyticsParams));
    var handleOnMouseDown = (0, $91i6m.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== "INPUT") event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $91i6m.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(ref) === "object") ref.current = inputElement;
        if (typeof ref === "function") ref(inputElement);
    }, [
        ref
    ]);
    var containerStyles = (0, $91i6m.useMemo)(function() {
        return (0, $4ucu0.containerStyles)(appearance, width);
    }, [
        appearance,
        width
    ]);
    var inputStyle = (0, $4ucu0.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ (0, $lPOF7.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        css: containerStyles,
        className: className
    }, elemBeforeInput, (0, $lPOF7.jsx)("input", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    })), elemAfterInput));
});
var $54339ad51eb86f63$export$2e2bcd8739ae039 = $54339ad51eb86f63$var$Textfield;

});
parcelRegister("4ucu0", function(module, exports) {

$parcel$export(module.exports, "containerStyles", function () { return $3443a59df996b78f$export$5972a68b6e54f38f; });
$parcel$export(module.exports, "inputStyles", function () { return $3443a59df996b78f$export$3eeb47dc8e6249d9; });

var $dsN6L = parcelRequire("dsN6L");

var $kLNLK = parcelRequire("kLNLK");
function $3443a59df996b78f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3443a59df996b78f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3443a59df996b78f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3443a59df996b78f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3443a59df996b78f$var$backgroundColor = {
    standard: "var(--ds-background-input, ".concat((0, $kLNLK.N10), ")"),
    subtle: "transparent",
    none: "transparent"
};
var $3443a59df996b78f$var$backgroundColorFocus = {
    standard: "var(--ds-background-input-pressed, ".concat((0, $kLNLK.N0), ")"),
    subtle: "var(--ds-background-input-pressed, ".concat((0, $kLNLK.N0), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$backgroundColorHover = {
    standard: "var(--ds-background-input-hovered, ".concat((0, $kLNLK.N30), ")"),
    subtle: "var(--ds-background-input-hovered, ".concat((0, $kLNLK.N30), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$borderColor = {
    standard: "var(--ds-border-input, ".concat((0, $kLNLK.N100), ")"),
    subtle: "transparent",
    none: "transparent"
};
var $3443a59df996b78f$var$borderColorFocus = {
    standard: "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"),
    subtle: "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$borderColorHover = {
    standard: "var(--ds-border-input, ".concat((0, $kLNLK.N100), ")"),
    subtle: "var(--ds-border-input, transparent)",
    none: "transparent"
};
var $3443a59df996b78f$var$getContainerTextBgAndBorderColor = function getContainerTextBgAndBorderColor(appearance) {
    return {
        backgroundColor: $3443a59df996b78f$var$backgroundColor[appearance],
        borderColor: $3443a59df996b78f$var$borderColor[appearance],
        color: "var(--ds-text, ".concat((0, $kLNLK.N900), ")"),
        cursor: "text",
        "&:hover:not([data-disabled])": {
            backgroundColor: $3443a59df996b78f$var$backgroundColorHover[appearance],
            borderColor: $3443a59df996b78f$var$borderColorHover[appearance]
        },
        "&:focus-within:not([data-disabled])": {
            backgroundColor: $3443a59df996b78f$var$backgroundColorFocus[appearance],
            borderColor: $3443a59df996b78f$var$borderColorFocus[appearance],
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $3443a59df996b78f$var$borderColorFocus[appearance])
        },
        "&[data-disabled]": $3443a59df996b78f$var$_objectSpread({
            color: "var(--ds-text-disabled, ".concat((0, $kLNLK.N70), ")"),
            cursor: "not-allowed"
        }, appearance === "standard" && {
            backgroundColor: "var(--ds-background-disabled, ".concat((0, $kLNLK.N10), ")"),
            borderColor: "var(--ds-background-disabled, ".concat((0, $kLNLK.N10), ")")
        }),
        "&[data-invalid], &[data-invalid]:hover": {
            borderColor: "var(--ds-border-danger, ".concat((0, $kLNLK.R400), ")"),
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, ".concat((0, $kLNLK.R400), ")"))
        },
        "&[data-invalid]:focus-within": {
            backgroundColor: "var(--ds-background-input-pressed, ".concat((0, $kLNLK.N0), ")"),
            borderColor: "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"),
            boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"))
        },
        "@media screen and (-ms-high-contrast: active)": {
            "&[data-invalid]:focus-within": {
                borderColor: "Highlight"
            },
            "&:focus-within": {
                borderColor: "Highlight"
            },
            "&[data-disabled]": {
                borderColor: "GrayText"
            }
        }
    };
};
var $3443a59df996b78f$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $3443a59df996b78f$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $3443a59df996b78f$var$widthMap ? $3443a59df996b78f$var$widthMap[width] : +width;
};
var $3443a59df996b78f$export$5972a68b6e54f38f = function containerStyles(appearance, width) {
    return $3443a59df996b78f$var$_objectSpread($3443a59df996b78f$var$_objectSpread($3443a59df996b78f$var$_objectSpread({
        alignItems: "center"
    }, $3443a59df996b78f$var$getContainerTextBgAndBorderColor(appearance)), {}, {
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)"
    }, appearance !== "none" ? {
        padding: "var(--ds-border-width, 1px)".concat(" 0")
    } : {}), {}, {
        borderStyle: appearance === "none" ? "none" : "solid",
        boxSizing: "border-box",
        display: "flex",
        flex: "1 1 100%",
        font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
        justifyContent: "space-between",
        maxWidth: $3443a59df996b78f$var$getMaxWidth(width),
        overflow: "hidden",
        transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",
        wordWrap: "break-word",
        verticalAlign: "top",
        pointerEvents: "auto"
    });
};
var $3443a59df996b78f$export$3eeb47dc8e6249d9 = function inputStyles() {
    return {
        backgroundColor: "transparent",
        border: 0,
        boxSizing: "border-box",
        color: "inherit",
        cursor: "inherit",
        font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
        minWidth: "0",
        outline: "none",
        width: "100%",
        "&[data-monospaced]": {
            fontFamily: 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)'
        },
        "&[data-compact]": {
            padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-075, 6px)")
        },
        "&:not([data-compact])": {
            padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-075, 6px)")
        },
        "&[disabled]": {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: "var(--ds-text-disabled, ".concat((0, $kLNLK.N70), ")")
        },
        // Hide the clear indicator on Edge (Windows only)
        "&::-ms-clear": {
            display: "none"
        },
        "&:invalid": {
            boxShadow: "none"
        },
        "&:placeholder-shown": {
            textOverflow: "ellipsis"
        },
        "&::placeholder": {
            color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.N200), ")"),
            "&:disabled": {
                color: "var(--ds-text-disabled, ".concat((0, $kLNLK.N70), ")")
            }
        },
        "@media screen and (-ms-high-contrast: active)": {
            "&[disabled]": {
                color: "GrayText"
            }
        }
    };
};

});


parcelRegister("9yEtj", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", function () { return $6f56aedca101884d$export$915e9e7bd4f0f96d; });
/** @jsx jsx */ 
var $lPOF7 = parcelRequire("lPOF7");

var $6m0jT = parcelRequire("6m0jT");

var $daZRO = parcelRequire("daZRO");

var $kLNLK = parcelRequire("kLNLK");

var $kROoV = parcelRequire("kROoV");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $6f56aedca101884d$var$messageStyles = (0, $lPOF7.css)({
    display: "flex",
    justifyContent: "baseline",
    gap: "var(--ds-space-050, 4px)",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    marginBlockStart: "var(--ds-space-050, 4px)"
});
var $6f56aedca101884d$var$messageAppearanceStyles = {
    default: (0, $lPOF7.css)({
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.N200), ")")
    }),
    error: (0, $lPOF7.css)({
        color: "var(--ds-text-danger, #AE2A19)"
    }),
    valid: (0, $lPOF7.css)({
        color: "var(--ds-text-success, #216E4E)"
    })
};
var $6f56aedca101884d$var$iconWrapperStyles = (0, $lPOF7.css)({
    display: "flex"
});
var $6f56aedca101884d$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return (0, $lPOF7.jsx)("span", {
        css: $6f56aedca101884d$var$iconWrapperStyles
    }, children);
};
var $6f56aedca101884d$var$messageIcons = {
    error: (0, $lPOF7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($daZRO))), {
        size: "small",
        label: "error"
    }),
    valid: (0, $lPOF7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6m0jT))), {
        size: "small",
        label: "success"
    })
};
var $6f56aedca101884d$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $6f56aedca101884d$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === "string" ? children : (0, $lPOF7.jsx)("span", null, children);
    return (0, $lPOF7.jsx)("div", {
        css: [
            $6f56aedca101884d$var$messageStyles,
            $6f56aedca101884d$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && (0, $lPOF7.jsx)($6f56aedca101884d$var$IconWrapper, null, icon), content);
};
var $6f56aedca101884d$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return (0, $lPOF7.jsx)((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return (0, $lPOF7.jsx)($6f56aedca101884d$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $6f56aedca101884d$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return (0, $lPOF7.jsx)((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return (0, $lPOF7.jsx)($6f56aedca101884d$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $6f56aedca101884d$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return (0, $lPOF7.jsx)((0, $kROoV.FieldId).Consumer, null, function(fieldId) {
        return (0, $lPOF7.jsx)($6f56aedca101884d$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};

});
parcelRegister("6m0jT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a050babc32300d7$var$_react = $4a050babc32300d7$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $4a050babc32300d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4a050babc32300d7$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $4a050babc32300d7$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$4a050babc32300d7$var$EditorSuccessIcon.displayName = "EditorSuccessIcon";
var $4a050babc32300d7$var$_default = $4a050babc32300d7$var$EditorSuccessIcon;
module.exports.default = $4a050babc32300d7$var$_default;

});



parcelRegister("8tnYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42aa2300f6a2cb0c$export$2e2bcd8739ae039; });

var $fqDmW = parcelRequire("fqDmW");

var $kLNLK = parcelRequire("kLNLK");
let $42aa2300f6a2cb0c$var$_ = (t)=>t, $42aa2300f6a2cb0c$var$t;
const $42aa2300f6a2cb0c$var$iconSize = "24px";
var $42aa2300f6a2cb0c$export$2e2bcd8739ae039 = (0, $fqDmW.default).span($42aa2300f6a2cb0c$var$t || ($42aa2300f6a2cb0c$var$t = $42aa2300f6a2cb0c$var$_`
  color: ${0};
  height: ${0};
  width: ${0};

  + div input {
    margin-right: ${0};
  }
`), (0, $kLNLK).N500, $42aa2300f6a2cb0c$var$iconSize, $42aa2300f6a2cb0c$var$iconSize, $42aa2300f6a2cb0c$var$iconSize);

});

parcelRegister("gaHKK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcb38136af8a7975$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $dcb38136af8a7975$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    loginFormUsernamePlaceholder: {
        id: "login.form.username.placeholder",
        defaultMessage: "Enter email"
    },
    loginFormUsernameLabel: {
        id: "login.form.username.label",
        defaultMessage: "Email"
    }
});

});


parcelRegister("9w0eB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b319ab9a4a7a53ac$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $gFwNN = parcelRequire("gFwNN");

var $c1txK = parcelRequire("c1txK");

var $cJRdM = parcelRequire("cJRdM");

var $leG06 = parcelRequire("leG06");

var $0wXBc = parcelRequire("0wXBc");
const $b319ab9a4a7a53ac$var$PasswordContainer = ({ className: className, fieldError: fieldError, isHidden: isHidden, onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const inputRef = (0, $91i6m.useRef)(null);
    const wasHidden = (0, $0wXBc.usePrevious)(isHidden);
    (0, $91i6m.useEffect)(()=>{
        var _inputRef_current;
        if (!isHidden && wasHidden) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        isHidden,
        wasHidden
    ]);
    const fieldErrorNode = fieldError ? /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
        id: "password-error",
        children: fieldError
    }) : fieldError;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
        isHidden: isHidden,
        className: className,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $c1txK.default), {
            id: "password",
            testId: "password" // used in pollinators
            ,
            name: "password",
            autoComplete: "current-password",
            placeholder: formatMessage((0, $cJRdM.default).passwordPlaceholder),
            label: formatMessage((0, $cJRdM.default).passwordLabel),
            autoFocus: !isHidden,
            isLabelHidden: true,
            onChange: onChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldErrorNode,
            value: value,
            ref: inputRef
        })
    });
};
var $b319ab9a4a7a53ac$export$2e2bcd8739ae039 = $b319ab9a4a7a53ac$var$PasswordContainer;

});
parcelRegister("cJRdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92a8e4c7e4d2e5c9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $92a8e4c7e4d2e5c9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    passwordPlaceholder: {
        id: "login.form.password.placeholder",
        defaultMessage: "Enter password"
    },
    passwordLabel: {
        id: "login.form.password.label",
        defaultMessage: "Password"
    }
});

});


parcelRegister("lkawQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eecdbb3e8b3e970b$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");
let $eecdbb3e8b3e970b$var$_ = (t)=>t, $eecdbb3e8b3e970b$var$t;
const $eecdbb3e8b3e970b$export$fbbb54563138a84f = (0, $fqDmW.default).div($eecdbb3e8b3e970b$var$t || ($eecdbb3e8b3e970b$var$t = $eecdbb3e8b3e970b$var$_`
  box-sizing: border-box;
  height: 39px;
  overflow: hidden;
  padding: 10px 9px;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Offset FieldGroup negative margin. */
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $eecdbb3e8b3e970b$var$RestrictedEmailContainer = ({ value: value })=>{
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $gFwNN.default), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)($eecdbb3e8b3e970b$export$fbbb54563138a84f, {
                title: value,
                children: value
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)("input", {
                "data-testid": "restricted-email-container",
                autoComplete: "username",
                type: "hidden",
                name: "username",
                value: value
            })
        ]
    });
};
var $eecdbb3e8b3e970b$export$2e2bcd8739ae039 = $eecdbb3e8b3e970b$var$RestrictedEmailContainer;

});

parcelRegister("31nHY", function(module, exports) {

$parcel$export(module.exports, "FormErrorWrapper", function () { return $807125d1ec365411$export$21ea266f0fa7d7c3; });
$parcel$export(module.exports, "default", function () { return $807125d1ec365411$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SectionError", function () { return $807125d1ec365411$export$1142f7f46d50535e; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");

var $8iEgn = parcelRequire("8iEgn");
let $807125d1ec365411$var$_ = (t)=>t, $807125d1ec365411$var$t, $807125d1ec365411$var$t1;
const $807125d1ec365411$export$21ea266f0fa7d7c3 = (0, $fqDmW.default).div($807125d1ec365411$var$t || ($807125d1ec365411$var$t = $807125d1ec365411$var$_`
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $807125d1ec365411$var$SectionErrorWrapper = (0, $fqDmW.default).div($807125d1ec365411$var$t1 || ($807125d1ec365411$var$t1 = $807125d1ec365411$var$_`
  margin-top: ${0}px;
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)());
function $807125d1ec365411$export$2e2bcd8739ae039({ testId: testId, title: title, children: children }) {
    return children ? /*#__PURE__*/ (0, $4ZSso.jsx)($807125d1ec365411$export$21ea266f0fa7d7c3, {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: testId || "form-error",
            appearance: "warning",
            title: title,
            children: children
        })
    }) : null;
}
function $807125d1ec365411$export$1142f7f46d50535e({ id: id, testId: testId, title: title, children: children }) {
    return children ? /*#__PURE__*/ (0, $4ZSso.jsx)($807125d1ec365411$var$SectionErrorWrapper, {
        id: id,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: testId || "form-error",
            appearance: "warning",
            title: title,
            children: children
        })
    }) : null;
}

});

parcelRegister("lnbpL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c71a1682cc4a680$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
let $5c71a1682cc4a680$var$_ = (t)=>t, $5c71a1682cc4a680$var$t;
const $5c71a1682cc4a680$var$FormInfo = (0, $fqDmW.default).div($5c71a1682cc4a680$var$t || ($5c71a1682cc4a680$var$t = $5c71a1682cc4a680$var$_`
  color: ${0};
  font-size: 13px;
  line-height: 17px;
  margin-bottom: 24px;
  margin-top: -4px;
  transform: rotateX(0deg);
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-bottom, opacity, transform, padding;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;
  text-align: center;

  &.hidden {
    height: 0;
    margin-bottom: 0;
    opacity: 0;
    padding: 0 ${0}px;
    pointer-events: none;
    transform: rotateX(-90deg);
    visibility: hidden;
  }
`), (0, $kLNLK).N700, (0, $6e88g.gridSize)() * 2);
const $5c71a1682cc4a680$var$FormInfoComponent = (_param)=>{
    var { children: children } = _param, props = (0, $6NU0v._)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($5c71a1682cc4a680$var$FormInfo, (0, $b2I6k._)((0, $1Fos3._)({
        role: "alert"
    }, props), {
        className: props.isHidden ? "hidden" : "",
        children: children
    }));
};
var $5c71a1682cc4a680$export$2e2bcd8739ae039 = $5c71a1682cc4a680$var$FormInfoComponent;

});

parcelRegister("j7UeI", function(module, exports) {

$parcel$export(module.exports, "StyledSocialLoginButton", function () { return $6b71b168e012af76$export$27110045cf7ea8db; });
$parcel$export(module.exports, "default", function () { return $6b71b168e012af76$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $6NU0v = parcelRequire("6NU0v");

var $4ZSso = parcelRequire("4ZSso");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
parcelRequire("91i6m");

var $leG06 = parcelRequire("leG06");

var $fqDmW = parcelRequire("fqDmW");

var $cbD68 = parcelRequire("cbD68");

var $UmWTx = parcelRequire("UmWTx");

var $4cs7R = parcelRequire("4cs7R");

var $7oaMt = parcelRequire("7oaMt");

var $ccxRw = parcelRequire("ccxRw");

var $ySUvx = parcelRequire("ySUvx");

var $cLysE = parcelRequire("cLysE");

var $8iEgn = parcelRequire("8iEgn");

var $cOOAJ = parcelRequire("cOOAJ");

var $9MKJ7 = parcelRequire("9MKJ7");

var $2UbF1 = parcelRequire("2UbF1");
let $6b71b168e012af76$var$_ = (t)=>t, $6b71b168e012af76$var$t, $6b71b168e012af76$var$t1, $6b71b168e012af76$var$t2, $6b71b168e012af76$var$t3;
const $6b71b168e012af76$export$969af4902a13348e = ({ handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const dynamicConfigs = (0, $2UbF1.useDynamicConfigs)();
    const googleOutageEnabled = (0, $ccxRw.isGoogleLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const microsoftOutageEnabled = (0, $ccxRw.isMicrosoftLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const appleOutageEnabled = (0, $ccxRw.isAppleLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const slackOutageEnabled = (0, $ccxRw.isSlackLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const isSocialLoginOutage = googleOutageEnabled || microsoftOutageEnabled || appleOutageEnabled || slackOutageEnabled;
    const getAdvisorySectionMessage = ()=>{
        const multipleOutages = [
            googleOutageEnabled,
            microsoftOutageEnabled,
            appleOutageEnabled,
            slackOutageEnabled
        ].filter(Boolean).length > 1;
        const sectionMessageTitle = multipleOutages ? formatMessage((0, $ySUvx.default).someOutageTitle) : getAdvisorySectionMessageTitle();
        const sectionMessageDescription = multipleOutages ? formatMessage((0, $ySUvx.default).someOutageDescription) : getAdvisorySectionMessageDescription();
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8iEgn.default), {
            testId: "social-login-outage-section-message",
            title: sectionMessageTitle,
            appearance: "warning",
            children: /*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                children: sectionMessageDescription
            })
        });
    };
    const getAdvisorySectionMessageTitle = ()=>googleOutageEnabled ? formatMessage((0, $ySUvx.default).googleOutageTitle) : microsoftOutageEnabled ? formatMessage((0, $ySUvx.default).microsoftOutageTitle) : appleOutageEnabled ? formatMessage((0, $ySUvx.default).appleOutageTitle) : slackOutageEnabled ? formatMessage((0, $ySUvx.default).slackOutageTitle) : formatMessage((0, $ySUvx.default).someOutageTitle);
    const getAdvisorySectionMessageDescription = ()=>googleOutageEnabled ? formatMessage((0, $ySUvx.default).googleOutageDescription) : microsoftOutageEnabled ? formatMessage((0, $ySUvx.default).microsoftOutageDescription) : appleOutageEnabled ? formatMessage((0, $ySUvx.default).appleOutageDescription) : slackOutageEnabled ? formatMessage((0, $ySUvx.default).slackOutageDescription) : formatMessage((0, $ySUvx.default).someOutageDescription);
    const GoogleButton = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "google-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($UmWTx))),
                onClick: handleGoogleLogin,
                advisoryEnabled: googleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).googleOutageDescription),
                children: "Google"
            })
        });
    };
    const MicrosoftButton = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "microsoft-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($4cs7R))),
                onClick: handleMicrosoftLogin,
                advisoryEnabled: microsoftOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).microsoftOutageDescription),
                children: "Microsoft"
            })
        });
    };
    const AppleButton = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "apple-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($cbD68))),
                onClick: handleAppleLogin,
                advisoryEnabled: appleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).appleOutageDescription),
                children: "Apple"
            })
        });
    };
    const SlackButton = ()=>{
        return /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginOptionWrapper, {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$var$SocialLoginButton, {
                id: "slack-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($7oaMt))),
                onClick: handleSlackLogin,
                advisoryEnabled: slackOutageEnabled,
                outageTooltipMessage: formatMessage((0, $ySUvx.default).slackOutageDescription),
                children: "Slack"
            })
        });
    };
    const showButtonsGridLayout = ()=>/*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$var$SocialLoginButtonRowGroup, {
                    "data-testid": "social-login-button-row",
                    children: [
                        GoogleButton(),
                        MicrosoftButton()
                    ]
                }),
                /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$var$SocialLoginButtonRowGroup, {
                    "data-testid": "social-login-button-row",
                    children: [
                        AppleButton(),
                        SlackButton()
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($6b71b168e012af76$export$e61ba37bbdbb1966, {
        "data-i18n-or": formatMessage((0, $ySUvx.default).socialAuthOr),
        "data-i18n-continue": formatMessage((0, $ySUvx.default).socialAuthOrContinueWith),
        className: "google-login social-login",
        "data-testid": "social-login-wrapper",
        children: [
            showButtonsGridLayout(),
            isSocialLoginOutage && getAdvisorySectionMessage()
        ]
    });
};
const $6b71b168e012af76$export$e61ba37bbdbb1966 = (0, $fqDmW.default).div($6b71b168e012af76$var$t || ($6b71b168e012af76$var$t = $6b71b168e012af76$var$_`
  margin-top: ${0}px;

  &::before {
    color: ${0};
    content: attr(data-i18n-continue);
    display: block;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: ${0}px;
    font-weight: 600;
    text-align: center;
  }
`), (0, $6e88g.gridSize)() * 3, (0, $kLNLK).N300, (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$var$SocialLoginButtonRowGroup = (0, $fqDmW.default).div($6b71b168e012af76$var$t1 || ($6b71b168e012af76$var$t1 = $6b71b168e012af76$var$_`
  &:not(:last-child) {
    margin-bottom: ${0}px;
  }
`), (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$var$SocialLoginOptionWrapper = (0, $fqDmW.default).div($6b71b168e012af76$var$t2 || ($6b71b168e012af76$var$t2 = $6b71b168e012af76$var$_`
  &:not(:last-child) {
    margin-bottom: ${0}px;
  }
`), (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$var$SocialLoginButton = (_param)=>{
    var { children: children, logo: logo, advisoryEnabled: advisoryEnabled, outageTooltipMessage: outageTooltipMessage } = _param, props = (0, $6NU0v._)(_param, [
        "children",
        "logo",
        "advisoryEnabled",
        "outageTooltipMessage"
    ]);
    const commonProps = {
        isFullWidth: true,
        iconBefore: /*#__PURE__*/ (0, $4ZSso.jsx)("img", {
            src: logo,
            alt: ""
        })
    };
    if (advisoryEnabled) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9MKJ7.default), {
        testId: "social-auth-button-tooltip",
        content: outageTooltipMessage,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$27110045cf7ea8db, (0, $b2I6k._)((0, $1Fos3._)({
            advisoryEnabled: true,
            iconAfter: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cOOAJ))), {
                testId: "social-auth-button-warning-icon",
                label: "",
                primaryColor: (0, $kLNLK).Y500,
                secondaryColor: (0, $kLNLK).Y50
            })
        }, commonProps, props), {
            children: children
        }))
    });
    else return /*#__PURE__*/ (0, $4ZSso.jsx)($6b71b168e012af76$export$27110045cf7ea8db, (0, $b2I6k._)((0, $1Fos3._)({
        advisoryEnabled: false
    }, commonProps, props), {
        children: children
    }));
};
const $6b71b168e012af76$export$27110045cf7ea8db = (0, $fqDmW.default)((0, $cLysE.default), {
    shouldForwardProp: (propName)=>![
            "advisoryEnabled"
        ].includes(propName)
})($6b71b168e012af76$var$t3 || ($6b71b168e012af76$var$t3 = $6b71b168e012af76$var$_`
  background: ${0} !important;
  box-shadow: none;
  font-weight: bold;
  border: 1px solid ${0};
  border-radius: 3px;
  color: ${0};
  span {
    flex-grow: unset;
  }

  &:not(:last-child) {
    margin-bottom: ${0}px;
  }

  &:hover {
    background: ${0} !important;
  }
  &:active {
    background: ${0} !important;
    color: ${0} !important;
  }
  &:focus {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(38, 132, 255, 0.6) !important;
  }
  img {
    height: 24px;
    width: 24px;
    margin-right: 6px;
  }
`), (props)=>props.advisoryEnabled ? (0, $kLNLK).Y50 : (0, $kLNLK).N0, (0, $kLNLK).N50, (0, $kLNLK).N800, (0, $6e88g.gridSize)() * 0.5, (0, $kLNLK).N10A, (0, $kLNLK).N20A, (0, $kLNLK).N400);
var $6b71b168e012af76$export$2e2bcd8739ae039 = $6b71b168e012af76$export$969af4902a13348e;

});
parcelRegister("cbD68", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL("01ogN") + "apple-logo.54e0d711.svg";

});

parcelRegister("UmWTx", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL("01ogN") + "google-logo.5867462c.svg";

});

parcelRegister("4cs7R", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL("01ogN") + "microsoft-logo.c73d8dca.svg";

});

parcelRegister("7oaMt", function(module, exports) {

module.exports = (parcelRequire("cgi2g")).getBundleURL("01ogN") + "slack-logo.5d730c10.svg";

});

parcelRegister("ySUvx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e74db0f439e21255$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $e74db0f439e21255$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    socialAuthOr: {
        id: "social.auth.or",
        defaultMessage: "or"
    },
    socialAuthOrContinueWith: {
        id: "social.auth.or-continue-with",
        defaultMessage: "Or continue with:"
    },
    socialAuthContinue: {
        id: "social.auth.continue",
        defaultMessage: "Or continue with",
        description: `Precedes third party login buttons. For example, "Or continue with Google"`
    },
    someOutageTitle: {
        id: "some.outage.title",
        defaultMessage: "Issues with some login options",
        description: "Message to the user that there are currently issues logging in with some providers due to an outage"
    },
    googleOutageTitle: {
        id: "google.outage.title",
        defaultMessage: "Issues with Google login",
        description: "Message to the user that there are currently issues logging in with Google due to an outage"
    },
    microsoftOutageTitle: {
        id: "microsoft.outage.title",
        defaultMessage: "Issues with Microsoft login",
        description: "Message to the user that there are currently issues logging in with Microsoft due to an outage"
    },
    appleOutageTitle: {
        id: "apple.outage.title",
        defaultMessage: "Issues with Apple login",
        description: "Message to the user that there are currently issues logging in with Apple due to an outage"
    },
    slackOutageTitle: {
        id: "slack.outage.title",
        defaultMessage: "Issues with Slack login",
        description: "Message to the user that there are currently issues logging in with Slack due to an outage"
    },
    someOutageDescription: {
        id: "some.outage.description",
        defaultMessage: "Some login options are experiencing issues at the moment. You may be able to log in or sign up with your email and password instead.",
        description: "Message to the user that there are currently issues logging in with due to a login provider outage"
    },
    googleOutageDescription: {
        id: "google.outage.description",
        defaultMessage: "There are issues with Google login and signup at the moment. If you are unable to continue with Google, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Google due to an outage"
    },
    microsoftOutageDescription: {
        id: "microsoft.outage.description",
        defaultMessage: "There are issues with Microsoft login and signup at the moment. If you are unable to continue with Microsoft, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Microsoft due to an outage"
    },
    appleOutageDescription: {
        id: "apple.outage.description",
        defaultMessage: "There are issues with Apple login and signup at the moment. If you are unable to continue with Apple, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Apple due to an outage"
    },
    slackOutageDescription: {
        id: "slack.outage.description",
        defaultMessage: "There are issues with Slack login and signup at the moment. If you are unable to continue with Slack, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Slack due to an outage"
    }
});

});

parcelRegister("cOOAJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $955165eea80d5a75$var$_react = $955165eea80d5a75$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $955165eea80d5a75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $955165eea80d5a75$var$WarningIcon = (props)=>/*#__PURE__*/ $955165eea80d5a75$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z" fill="currentColor"/><path d="M12 15a1 1 0 01-1-1V9a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$955165eea80d5a75$var$WarningIcon.displayName = "WarningIcon";
var $955165eea80d5a75$var$_default = $955165eea80d5a75$var$WarningIcon;
module.exports.default = $955165eea80d5a75$var$_default;

});


parcelRegister("jthWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97147eacdc47bb45$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $97147eacdc47bb45$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    unexpectedErrorHappened: {
        id: "login.form.sso.check.unknown.error",
        defaultMessage: "Unexpected error happened.",
        description: ""
    },
    emailPlaceholder: {
        id: "login.form.email.placeholder",
        defaultMessage: "Enter your email"
    },
    emailEmpty: {
        id: "login.form.email.empty",
        defaultMessage: "Enter an email address"
    },
    passwordEmpty: {
        id: "login.form.password.empty",
        defaultMessage: "Enter your password"
    },
    migrateAccountInfo: {
        id: "login.form.info.migrate.account",
        defaultMessage: "It looks like you already have an Atlassian account with other products such as Jira or Confluence. Log in to finish migrating your {application} account.",
        description: "Login form info container message"
    },
    existingUserSignupAttemptInfo: {
        id: "login.form.info.existing.user.signup.attempt",
        defaultMessage: "It looks like you've already got an account associated with this email. Log in instead or reset your password if you've forgotten it",
        description: "Login form info container message for existing user signup attempt"
    },
    rateLimitErrorMessage: {
        id: "login.form.email.rate-limit-exceeded.error",
        defaultMessage: "There have been too many attempts to reverify your account in the past hour. Please try again later.",
        description: "Telling the user that they have exceeded welcome email limit"
    },
    rememberMeCheckboxLabel: {
        id: "login.form.remember.me.checkbox.label",
        defaultMessage: "Remember me",
        description: "Label for the checkbox that will enable the behaviour to remember a user's account on this device"
    },
    rememberMeTooltip: {
        id: "login.form.remember.me.tooltip",
        defaultMessage: "We remember your account information for the next time you log in.",
        description: "Tooltip content for the remember me checkbox"
    }
});

});

parcelRegister("brCu8", function(module, exports) {

$parcel$export(module.exports, "useTranslateFormErrorIfAvailable", function () { return $9c7488dbc3e314ea$export$61b698e3c147347c; });

var $j5RJC = parcelRequire("j5RJC");
var $leG06 = parcelRequire("leG06");
const $9c7488dbc3e314ea$export$61b698e3c147347c = (formError)=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const message = Object.values($9c7488dbc3e314ea$var$formValidationMessages).find(({ id: id })=>id === formError);
    if (message) return formatMessage(message);
    else return formError;
};
const $9c7488dbc3e314ea$var$formValidationMessages = (0, $j5RJC.defineMessages)({
    unknownError: {
        id: "com.atlassian.profile.unknownError",
        defaultMessage: "An unknown error occurred"
    },
    errorRequiredField: {
        id: "error.required",
        defaultMessage: "This field is required"
    },
    loginFormNoPassword: {
        id: "login.form.no.password",
        defaultMessage: "Enter your password"
    },
    loginFormPasswordTooLong: {
        id: "login.form.password.too.long",
        defaultMessage: "Password length capped at 100 characters"
    },
    loginFormPasswordTooShort: {
        id: "login.form.password.too.short",
        defaultMessage: "The password is too short."
    },
    resetPasswordGenericError: {
        id: "resetPassword.error",
        defaultMessage: "An error occurred while attempting to reset your password."
    },
    resetPasswordEmailFormatError: {
        id: "requestPasswordReset.email.format.error",
        defaultMessage: "Please enter a valid email address"
    },
    signupDisplayNameEmpty: {
        id: "signup.display.name.empty",
        defaultMessage: "Full name must not be empty"
    },
    signupDisplayNameTooLong: {
        id: "signup.display.name.too.long",
        defaultMessage: "Full name must not be greater than 255 characters"
    },
    signupEmailFormatError: {
        id: "signup.email.format.error",
        defaultMessage: "Email is required to be in correct format"
    },
    signupEmailReachedMaxAliases: {
        id: "signup.email.reached.max.aliases",
        defaultMessage: "Email aliases are rate limited"
    },
    signupEmailRestrictedDomain: {
        id: "signup.email.restricted.domain.error",
        defaultMessage: "The provided email address is not allowed, please use a different one"
    },
    signupGenericFailure: {
        id: "signup.failure",
        defaultMessage: "We are unable to sign you up. Please contact support."
    },
    signupCaptchaResponseError: {
        id: "signup.captcha.response.required.error",
        defaultMessage: "Are you sure you're not a robot?"
    }
});

});

parcelRegister("1a5r2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d8af0efc0b94215$var$_react = $0d8af0efc0b94215$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $0d8af0efc0b94215$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0d8af0efc0b94215$var$InfoIcon = (props)=>/*#__PURE__*/ $0d8af0efc0b94215$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$0d8af0efc0b94215$var$InfoIcon.displayName = "InfoIcon";
var $0d8af0efc0b94215$var$_default = $0d8af0efc0b94215$var$InfoIcon;
module.exports.default = $0d8af0efc0b94215$var$_default;

});

parcelRegister("9X0U9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73ea536a25fc5dee$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $7re4P = parcelRequire("7re4P");

var $lBrex = parcelRequire("lBrex");

var $3W7HL = parcelRequire("3W7HL");
var $73ea536a25fc5dee$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $73ea536a25fc5dee$var$_excluded2 = [
    "className"
];
var $73ea536a25fc5dee$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $73ea536a25fc5dee$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(htmlAttributes, $73ea536a25fc5dee$var$_excluded2);
    var resolvedStyles = (0, $lBrex.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $lPOF7.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $73ea536a25fc5dee$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $7re4P.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7re4P.isSurfaceColorToken)(backgroundColor) && (0, $7re4P.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $7re4P.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $7re4P.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $7re4P.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $7re4P.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $7re4P.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $7re4P.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $7re4P.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $lPOF7.jsx)((0, $3W7HL.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $73ea536a25fc5dee$export$2e2bcd8739ae039 = $73ea536a25fc5dee$export$e71c4d32a2263218;
var $73ea536a25fc5dee$var$baseStyles = (0, $lPOF7.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("7re4P", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $56a5f967a4df8085$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $56a5f967a4df8085$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $56a5f967a4df8085$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $56a5f967a4df8085$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $56a5f967a4df8085$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $56a5f967a4df8085$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $56a5f967a4df8085$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $56a5f967a4df8085$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $56a5f967a4df8085$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $56a5f967a4df8085$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $56a5f967a4df8085$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $56a5f967a4df8085$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $56a5f967a4df8085$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $56a5f967a4df8085$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $56a5f967a4df8085$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $56a5f967a4df8085$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $56a5f967a4df8085$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $56a5f967a4df8085$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $56a5f967a4df8085$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "textSizeStylesMap", function () { return $56a5f967a4df8085$export$219d364c0da35ae4; });
$parcel$export(module.exports, "textWeightStylesMap", function () { return $56a5f967a4df8085$export$38845ca010b93505; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $56a5f967a4df8085$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $56a5f967a4df8085$export$5e65a44e5b6ecadb; });

var $dsN6L = parcelRequire("dsN6L");

var $lPOF7 = parcelRequire("lPOF7");

var $aXjaN = parcelRequire("aXjaN");
function $56a5f967a4df8085$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56a5f967a4df8085$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56a5f967a4df8085$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56a5f967a4df8085$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $56a5f967a4df8085$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $56a5f967a4df8085$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $56a5f967a4df8085$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $56a5f967a4df8085$export$632685d741f3dbbf = $56a5f967a4df8085$var$_objectSpread($56a5f967a4df8085$var$_objectSpread({}, $56a5f967a4df8085$export$958d0ae7f2977ae4), $56a5f967a4df8085$export$d2dc61f58390201c);
var $56a5f967a4df8085$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $56a5f967a4df8085$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $56a5f967a4df8085$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $56a5f967a4df8085$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $56a5f967a4df8085$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $56a5f967a4df8085$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $56a5f967a4df8085$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $56a5f967a4df8085$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $56a5f967a4df8085$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $56a5f967a4df8085$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $56a5f967a4df8085$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $56a5f967a4df8085$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $56a5f967a4df8085$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $56a5f967a4df8085$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $56a5f967a4df8085$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $56a5f967a4df8085$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $56a5f967a4df8085$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $56a5f967a4df8085$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $lPOF7.css)((0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $56a5f967a4df8085$export$e615f061ca585a6c = $56a5f967a4df8085$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $56a5f967a4df8085$export$ca0f9c2de39ffed7(spacingProperty, $56a5f967a4df8085$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $56a5f967a4df8085$export$bf46c3f9eeafc71f = $56a5f967a4df8085$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $56a5f967a4df8085$export$ca0f9c2de39ffed7(spacingProperty, $56a5f967a4df8085$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $56a5f967a4df8085$export$e7af83bafe7f9e63 = $56a5f967a4df8085$export$ca0f9c2de39ffed7("backgroundColor", $56a5f967a4df8085$export$d1d79bf68ac056bd);
var $56a5f967a4df8085$export$3a1bcba60b23d7f0 = $56a5f967a4df8085$export$ca0f9c2de39ffed7("color", $56a5f967a4df8085$export$8473307aa00d6ea1);
var $56a5f967a4df8085$export$45f3f4fe16f9f7d5 = $56a5f967a4df8085$export$ca0f9c2de39ffed7("fontWeight", $56a5f967a4df8085$export$303e322c6b1ed114);
var $56a5f967a4df8085$export$68cc305da27dbaa4 = $56a5f967a4df8085$export$ca0f9c2de39ffed7("fontFamily", $56a5f967a4df8085$export$3c7e9587132614b4);
var $56a5f967a4df8085$export$128f10c238242f83 = $56a5f967a4df8085$export$ca0f9c2de39ffed7("font", $56a5f967a4df8085$export$6ffa317d5e70375);
var $56a5f967a4df8085$export$219d364c0da35ae4 = $56a5f967a4df8085$export$ca0f9c2de39ffed7("font", $56a5f967a4df8085$export$236bfe3a33ef1292);
var $56a5f967a4df8085$export$38845ca010b93505 = $56a5f967a4df8085$export$ca0f9c2de39ffed7("fontWeight", $56a5f967a4df8085$export$855cfd311192d666);
var $56a5f967a4df8085$export$ff257d957d48c421 = $56a5f967a4df8085$export$ca0f9c2de39ffed7((0, $aXjaN.CURRENT_SURFACE_CSS_VAR), $56a5f967a4df8085$export$41a358c9c2356760);
var $56a5f967a4df8085$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $56a5f967a4df8085$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("aXjaN", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $7f9e4973358f6c2f$export$9d7b58831ae93caa; });
var $7f9e4973358f6c2f$export$4ef52930e33717cd = "data-theme";
var $7f9e4973358f6c2f$export$a00eac3f8684bcd0 = "data-color-mode";
var $7f9e4973358f6c2f$export$2112803007239c61 = "data-contrast-mode";
var $7f9e4973358f6c2f$export$352e418ed5b6193a = "data-custom-theme";
var $7f9e4973358f6c2f$export$2faeed762aac6741 = "light";
var $7f9e4973358f6c2f$export$6f0c6fb8c80fcc92 = "ds";
var $7f9e4973358f6c2f$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $7f9e4973358f6c2f$export$dddac1532e822863 = "--".concat($7f9e4973358f6c2f$export$6f0c6fb8c80fcc92, "-token-not-found");
var $7f9e4973358f6c2f$export$9d7b58831ae93caa = "--".concat($7f9e4973358f6c2f$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("lBrex", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $fba22db24ccc945a$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $fba22db24ccc945a$export$f6c783d06584602c; });

var $iqLBO = parcelRequire("iqLBO");

var $dsN6L = parcelRequire("dsN6L");

var $5YM7L = parcelRequire("5YM7L");

var $61RDg = parcelRequire("61RDg");

var $lPOF7 = parcelRequire("lPOF7");

var $7re4P = parcelRequire("7re4P");

var $e08gr = parcelRequire("e08gr");
function $fba22db24ccc945a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $fba22db24ccc945a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $fba22db24ccc945a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fba22db24ccc945a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fba22db24ccc945a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fba22db24ccc945a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $fba22db24ccc945a$export$9a199fbafee0014e = {
    backgroundColor: (0, $7re4P.backgroundColorMap),
    blockSize: (0, $7re4P.dimensionMap),
    borderBlockColor: (0, $7re4P.borderColorMap),
    borderBlockEndColor: (0, $7re4P.borderColorMap),
    borderBlockEndWidth: (0, $7re4P.borderWidthMap),
    borderBlockStartColor: (0, $7re4P.borderColorMap),
    borderBlockStartWidth: (0, $7re4P.borderWidthMap),
    borderBlockWidth: (0, $7re4P.borderWidthMap),
    borderBottomColor: (0, $7re4P.borderColorMap),
    borderBottomLeftRadius: (0, $7re4P.borderRadiusMap),
    borderBottomRightRadius: (0, $7re4P.borderRadiusMap),
    borderBottomWidth: (0, $7re4P.borderWidthMap),
    borderColor: (0, $7re4P.borderColorMap),
    borderEndEndRadius: (0, $7re4P.borderRadiusMap),
    borderEndStartRadius: (0, $7re4P.borderRadiusMap),
    borderInlineColor: (0, $7re4P.borderColorMap),
    borderInlineEndColor: (0, $7re4P.borderColorMap),
    borderInlineEndWidth: (0, $7re4P.borderWidthMap),
    borderInlineStartColor: (0, $7re4P.borderColorMap),
    borderInlineStartWidth: (0, $7re4P.borderWidthMap),
    borderInlineWidth: (0, $7re4P.borderWidthMap),
    borderLeftColor: (0, $7re4P.borderColorMap),
    borderLeftWidth: (0, $7re4P.borderWidthMap),
    borderRadius: (0, $7re4P.borderRadiusMap),
    borderRightColor: (0, $7re4P.borderColorMap),
    borderRightWidth: (0, $7re4P.borderWidthMap),
    borderStartEndRadius: (0, $7re4P.borderRadiusMap),
    borderStartStartRadius: (0, $7re4P.borderRadiusMap),
    borderTopColor: (0, $7re4P.borderColorMap),
    borderTopLeftRadius: (0, $7re4P.borderRadiusMap),
    borderTopRightRadius: (0, $7re4P.borderRadiusMap),
    borderTopWidth: (0, $7re4P.borderWidthMap),
    borderWidth: (0, $7re4P.borderWidthMap),
    bottom: (0, $7re4P.allSpaceMap),
    boxShadow: (0, $7re4P.shadowMap),
    color: (0, $7re4P.textColorMap),
    columnGap: (0, $7re4P.positiveSpaceMap),
    font: (0, $7re4P.fontMap),
    fontFamily: (0, $7re4P.fontFamilyMap),
    fontWeight: (0, $7re4P.fontWeightMap),
    gap: (0, $7re4P.positiveSpaceMap),
    height: (0, $7re4P.dimensionMap),
    inlineSize: (0, $7re4P.dimensionMap),
    inset: (0, $7re4P.allSpaceMap),
    insetBlock: (0, $7re4P.allSpaceMap),
    insetBlockEnd: (0, $7re4P.allSpaceMap),
    insetBlockStart: (0, $7re4P.allSpaceMap),
    insetInline: (0, $7re4P.allSpaceMap),
    insetInlineEnd: (0, $7re4P.allSpaceMap),
    insetInlineStart: (0, $7re4P.allSpaceMap),
    left: (0, $7re4P.allSpaceMap),
    margin: (0, $7re4P.allSpaceMap),
    marginBlock: (0, $7re4P.allSpaceMap),
    marginBlockEnd: (0, $7re4P.allSpaceMap),
    marginBlockStart: (0, $7re4P.allSpaceMap),
    marginBottom: (0, $7re4P.allSpaceMap),
    marginInline: (0, $7re4P.allSpaceMap),
    marginInlineEnd: (0, $7re4P.allSpaceMap),
    marginInlineStart: (0, $7re4P.allSpaceMap),
    marginLeft: (0, $7re4P.allSpaceMap),
    marginRight: (0, $7re4P.allSpaceMap),
    marginTop: (0, $7re4P.allSpaceMap),
    maxBlockSize: (0, $7re4P.dimensionMap),
    maxHeight: (0, $7re4P.dimensionMap),
    maxInlineSize: (0, $7re4P.dimensionMap),
    maxWidth: (0, $7re4P.dimensionMap),
    minBlockSize: (0, $7re4P.dimensionMap),
    minHeight: (0, $7re4P.dimensionMap),
    minInlineSize: (0, $7re4P.dimensionMap),
    minWidth: (0, $7re4P.dimensionMap),
    opacity: (0, $7re4P.opacityMap),
    outlineColor: (0, $7re4P.borderColorMap),
    outlineOffset: (0, $7re4P.positiveSpaceMap),
    outlineWidth: (0, $7re4P.borderWidthMap),
    padding: (0, $7re4P.positiveSpaceMap),
    paddingBlock: (0, $7re4P.positiveSpaceMap),
    paddingBlockEnd: (0, $7re4P.positiveSpaceMap),
    paddingBlockStart: (0, $7re4P.positiveSpaceMap),
    paddingBottom: (0, $7re4P.positiveSpaceMap),
    paddingInline: (0, $7re4P.positiveSpaceMap),
    paddingInlineEnd: (0, $7re4P.positiveSpaceMap),
    paddingInlineStart: (0, $7re4P.positiveSpaceMap),
    paddingLeft: (0, $7re4P.positiveSpaceMap),
    paddingRight: (0, $7re4P.positiveSpaceMap),
    paddingTop: (0, $7re4P.positiveSpaceMap),
    right: (0, $7re4P.allSpaceMap),
    rowGap: (0, $7re4P.positiveSpaceMap),
    top: (0, $7re4P.allSpaceMap),
    width: (0, $7re4P.dimensionMap),
    zIndex: (0, $7re4P.layerMap)
};
var $fba22db24ccc945a$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $fba22db24ccc945a$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $e08gr === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))($e08gr)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))($e08gr.env) === "object" && false;
};
var $fba22db24ccc945a$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $fba22db24ccc945a$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $fba22db24ccc945a$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(value) === "object" && $fba22db24ccc945a$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($fba22db24ccc945a$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($fba22db24ccc945a$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $fba22db24ccc945a$export$9a199fbafee0014e)) return;
        var tokenValue = $fba22db24ccc945a$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $fba22db24ccc945a$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $fba22db24ccc945a$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))({}, $fba22db24ccc945a$var$uniqueSymbol, (0, $lPOF7.css)(transformedStyles));
};
var $fba22db24ccc945a$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $fba22db24ccc945a$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($iqLBO)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$fba22db24ccc945a$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $fba22db24ccc945a$export$f6c783d06584602c(style) {
    return $fba22db24ccc945a$var$baseXcss(style);
}

});

parcelRegister("3W7HL", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $2ddcc3eb387ba43c$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $2ddcc3eb387ba43c$export$1aeb4f6b93c4540d; });

var $91i6m = parcelRequire("91i6m");
var $2ddcc3eb387ba43c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $91i6m.createContext)("elevation.surface");
var $2ddcc3eb387ba43c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $91i6m.useContext)($2ddcc3eb387ba43c$export$1ca2a26fecb070ae);
};
$2ddcc3eb387ba43c$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("c32T7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c58015664b03a7f$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $7re4P = parcelRequire("7re4P");

var $lBrex = parcelRequire("lBrex");
var $8c58015664b03a7f$var$justifyContentMap = {
    start: (0, $lPOF7.css)({
        justifyContent: "start"
    }),
    center: (0, $lPOF7.css)({
        justifyContent: "center"
    }),
    end: (0, $lPOF7.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $lPOF7.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $lPOF7.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $lPOF7.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $lPOF7.css)({
        justifyContent: "stretch"
    })
};
var $8c58015664b03a7f$var$flexDirectionMap = {
    column: (0, $lPOF7.css)({
        flexDirection: "column"
    }),
    row: (0, $lPOF7.css)({
        flexDirection: "row"
    })
};
var $8c58015664b03a7f$var$flexWrapMap = {
    wrap: (0, $lPOF7.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $lPOF7.css)({
        flexWrap: "nowrap"
    })
};
var $8c58015664b03a7f$var$alignItemsMap = {
    start: (0, $lPOF7.css)({
        alignItems: "start"
    }),
    center: (0, $lPOF7.css)({
        alignItems: "center"
    }),
    baseline: (0, $lPOF7.css)({
        alignItems: "baseline"
    }),
    end: (0, $lPOF7.css)({
        alignItems: "end"
    }),
    stretch: (0, $lPOF7.css)({
        alignItems: "stretch"
    })
};
var $8c58015664b03a7f$var$baseStyles = (0, $lPOF7.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $8c58015664b03a7f$var$Flex = /*#__PURE__*/ (0, $91i6m.memo)(/*#__PURE__*/ (0, $91i6m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $lBrex.parseXcss)(xcss);
    return (0, $lPOF7.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $8c58015664b03a7f$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $7re4P.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $7re4P.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $7re4P.spaceStylesMap).rowGap[rowGap],
            alignItems && $8c58015664b03a7f$var$alignItemsMap[alignItems],
            direction && $8c58015664b03a7f$var$flexDirectionMap[direction],
            justifyContent && $8c58015664b03a7f$var$justifyContentMap[justifyContent],
            wrap && $8c58015664b03a7f$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$8c58015664b03a7f$var$Flex.displayName = "Flex";
var $8c58015664b03a7f$export$2e2bcd8739ae039 = $8c58015664b03a7f$var$Flex;

});


parcelRegister("gKURT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4108e007ab21b5b$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");

var $kLNLK = parcelRequire("kLNLK");

var $cLysE = parcelRequire("cLysE");

var $7cVVr = parcelRequire("7cVVr");

var $UmWTx = parcelRequire("UmWTx");

var $4cs7R = parcelRequire("4cs7R");

var $cbD68 = parcelRequire("cbD68");

var $7oaMt = parcelRequire("7oaMt");

var $gtKO2 = parcelRequire("gtKO2");
let $c4108e007ab21b5b$var$_ = (t)=>t, $c4108e007ab21b5b$var$t, $c4108e007ab21b5b$var$t1, $c4108e007ab21b5b$var$t2, $c4108e007ab21b5b$var$t3;
const $c4108e007ab21b5b$var$SocialLoginBlock = (0, $fqDmW.default).div($c4108e007ab21b5b$var$t || ($c4108e007ab21b5b$var$t = $c4108e007ab21b5b$var$_`
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${0}px;

  border: 1px solid ${0};
  border-radius: 3px;
`), (0, $6e88g.gridSize)() * 1.5, (0, $kLNLK.N50));
const $c4108e007ab21b5b$var$Header = (0, $fqDmW.default).div($c4108e007ab21b5b$var$t1 || ($c4108e007ab21b5b$var$t1 = $c4108e007ab21b5b$var$_`
  display: flex;
  align-self: center;
  justify-content: center;

  width: 100%;
  padding-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 1.5);
const $c4108e007ab21b5b$var$Email = (0, $fqDmW.default).div($c4108e007ab21b5b$var$t2 || ($c4108e007ab21b5b$var$t2 = $c4108e007ab21b5b$var$_`
  font-weight: 600;
  font-size: 14px;
  line-height: ${0}px;
  color: ${0};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`), (0, $6e88g.gridSize)() * 3, (0, $kLNLK.N800));
const $c4108e007ab21b5b$var$Logo = (0, $fqDmW.default).img($c4108e007ab21b5b$var$t3 || ($c4108e007ab21b5b$var$t3 = $c4108e007ab21b5b$var$_`
  height: ${0}px;
  padding-right: ${0}px;
`), (0, $6e88g.gridSize)() * 3, (0, $6e88g.gridSize)());
const $c4108e007ab21b5b$var$getLogo = (highlightedSocialProvider)=>{
    switch(highlightedSocialProvider){
        case (0, $gtKO2.SocialProvider).Google:
            return 0, (/*@__PURE__*/$parcel$interopDefault($UmWTx));
        case (0, $gtKO2.SocialProvider).Microsoft:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4cs7R));
        case (0, $gtKO2.SocialProvider).Apple:
            return 0, (/*@__PURE__*/$parcel$interopDefault($cbD68));
        case (0, $gtKO2.SocialProvider).Slack:
            return 0, (/*@__PURE__*/$parcel$interopDefault($7oaMt));
    }
};
const $c4108e007ab21b5b$var$getSocialLoginHandler = ({ highlightedSocialProvider: highlightedSocialProvider, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    switch(highlightedSocialProvider){
        case (0, $gtKO2.SocialProvider).Google:
            return handleGoogleLogin;
        case (0, $gtKO2.SocialProvider).Microsoft:
            return handleMicrosoftLogin;
        case (0, $gtKO2.SocialProvider).Apple:
            return handleAppleLogin;
        case (0, $gtKO2.SocialProvider).Slack:
            return handleSlackLogin;
    }
};
const $c4108e007ab21b5b$var$SocialLoginForm = (props)=>{
    const { highlightedSocialProvider: highlightedSocialProvider, email: email } = props;
    const handleSocialLogin = $c4108e007ab21b5b$var$getSocialLoginHandler(props);
    return /*#__PURE__*/ (0, $4ZSso.jsxs)($c4108e007ab21b5b$var$SocialLoginBlock, {
        "data-testid": "social-login-form",
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)($c4108e007ab21b5b$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)($c4108e007ab21b5b$var$Logo, {
                        src: $c4108e007ab21b5b$var$getLogo(highlightedSocialProvider),
                        alt: `${highlightedSocialProvider} logo`
                    }),
                    email && /*#__PURE__*/ (0, $4ZSso.jsx)($c4108e007ab21b5b$var$Email, {
                        children: email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
                isFullWidth: true,
                id: "social-login-submit",
                appearance: "primary",
                onClick: handleSocialLogin,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({}, (0, $7cVVr.default).continueWith), {
                    values: {
                        socialProviderName: highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
                    }
                }))
            })
        ]
    });
};
var $c4108e007ab21b5b$export$2e2bcd8739ae039 = $c4108e007ab21b5b$var$SocialLoginForm;

});
parcelRegister("7cVVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b70b522f9e02cef9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $b70b522f9e02cef9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    continueWith: {
        id: "social.login.form.continue-button",
        defaultMessage: "Continue with {socialProviderName}",
        description: "Button label that is a CTA for users to continue logging in using the selected social provider."
    }
});

});


parcelRegister("gx7I6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb3609afe7f9a073$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $8Bf3D = parcelRequire("8Bf3D");

var $bE8z6 = parcelRequire("bE8z6");

var $g6OTd = parcelRequire("g6OTd");

var $7eeh4 = parcelRequire("7eeh4");

var $1TbRW = parcelRequire("1TbRW");
const $cb3609afe7f9a073$var$Footer = ({ isEmbedded: isEmbedded, oidcContext: oidcContext })=>{
    if (isEmbedded || !oidcContext) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
                className: "fine-print",
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.PrivacyPolicyLink), {
                            isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
                        })
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $bE8z6.UserNoticeLink), {
                            isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1TbRW.RecaptchaNoticeContainer), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $g6OTd.RecaptchaNotice), {})
            })
        ]
    });
};
var $cb3609afe7f9a073$export$2e2bcd8739ae039 = $cb3609afe7f9a073$var$Footer;

});
parcelRegister("8Bf3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8598e8620eefabcf$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");
let $8598e8620eefabcf$var$_ = (t)=>t, $8598e8620eefabcf$var$t;
const $8598e8620eefabcf$var$SeparatorContainer = (0, $fqDmW.default).p($8598e8620eefabcf$var$t || ($8598e8620eefabcf$var$t = $8598e8620eefabcf$var$_`
  margin: 0px 8px;
`));
const $8598e8620eefabcf$var$Bull = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)($8598e8620eefabcf$var$SeparatorContainer, {
        children: "\u2022"
    });
var $8598e8620eefabcf$export$2e2bcd8739ae039 = $8598e8620eefabcf$var$Bull;

});


parcelRegister("4tmE5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dde66b37a92d3c19$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $b2I6k = parcelRequire("b2I6k");

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $9b70D = parcelRequire("9b70D");
const $dde66b37a92d3c19$var$Header = ({ highlightedSocialProvider: highlightedSocialProvider, showSocialLoginOnly: showSocialLoginOnly })=>{
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $b2I6k._)((0, $1Fos3._)({
        tagName: "h5"
    }, (0, $9b70D.LoginPageMessages).socialFormTitle), {
        values: {
            socialProviderName: highlightedSocialProvider === null || highlightedSocialProvider === void 0 ? void 0 : highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
        }
    }));
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({
        tagName: "h5"
    }, (0, $9b70D.LoginPageMessages).headTitle));
};
var $dde66b37a92d3c19$export$2e2bcd8739ae039 = $dde66b37a92d3c19$var$Header;

});

parcelRegister("k3QGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $977fc0c59633125c$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $j7UeI = parcelRequire("j7UeI");
const $977fc0c59633125c$var$MaybeSocialLoginPanel = ({ isEmbedded: isEmbedded, isSocialBlocked: isSocialBlocked, envSupportsSocialLogin: envSupportsSocialLogin, onGoogleLogin: onGoogleLogin, onMicrosoftLogin: onMicrosoftLogin, onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin })=>{
    if (!envSupportsSocialLogin || isEmbedded || isSocialBlocked) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.default), {
        handleGoogleLogin: onGoogleLogin,
        handleMicrosoftLogin: onMicrosoftLogin,
        handleAppleLogin: onAppleLogin,
        handleSlackLogin: onSlackLogin
    });
};
var $977fc0c59633125c$export$2e2bcd8739ae039 = $977fc0c59633125c$var$MaybeSocialLoginPanel;

});

parcelRegister("68WXR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ef3e311772fd3c0$export$2e2bcd8739ae039; });

var $1Fos3 = parcelRequire("1Fos3");

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $6d87w = parcelRequire("6d87w");

var $dBq8m = parcelRequire("dBq8m");

var $2aGBJ = parcelRequire("2aGBJ");

var $k8MAo = parcelRequire("k8MAo");

var $8Bf3D = parcelRequire("8Bf3D");

var $64QTD = parcelRequire("64QTD");

var $gtKO2 = parcelRequire("gtKO2");

var $7eeh4 = parcelRequire("7eeh4");

var $1V2cH = parcelRequire("1V2cH");

var $bqdjD = parcelRequire("bqdjD");

var $9b70D = parcelRequire("9b70D");

var $1UkGo = parcelRequire("1UkGo");

var $6OnpU = parcelRequire("6OnpU");
const $1ef3e311772fd3c0$var$WhiteboxFooter = ({ isMobileApp: isMobileApp, oidcContext: oidcContext, showSocialLoginOnly: showSocialLoginOnly })=>{
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const isCommercial = (0, $bqdjD.getCurrentPerimeter)() === "commercial";
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    const signupLinkEnabled = (0, $91i6m.useMemo)(()=>{
        // Due to Apple Store rules, we don't want sign up link on login page in Mobile OAuth case, unless we provide redirection from login to signup
        const shouldRenderSignupLink = isCommercial && (!isMobileApp || (0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).LoginWithRedirect));
        return queryParams.shide !== "true" && shouldRenderSignupLink;
    }, [
        isCommercial,
        isMobileApp,
        oidcContext,
        queryParams.shide
    ]);
    const getSignupLinkElement = ()=>{
        if (signupLinkEnabled) {
            const elementText = /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $9b70D.LoginPageMessages).createAnAccount));
            return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
                to: "/signup" + location.search,
                id: "signup",
                className: "primary-action",
                onClick: ()=>{
                    analyticsClient.linkClickedEvent((0, $1UkGo.pageId), "signUpLink");
                },
                children: elementText
            });
        }
        return null;
    };
    const signupLink = getSignupLinkElement();
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $64QTD.default), {
        id: "use-a-different-login-method",
        spacing: "none",
        onClick: ()=>{
            dispatch((0, $k8MAo.resetLoginForm)());
        },
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), (0, $1Fos3._)({}, (0, $9b70D.LoginPageMessages).socialFormUseDifferentLoginMethod))
    });
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("ul", {
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6OnpU.ResetPasswordLink), {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                        id: "trouble.logging.in",
                        defaultMessage: "Can't log in?"
                    })
                })
            }),
            signupLink && /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $4ZSso.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $8Bf3D.default), {}),
                    /*#__PURE__*/ (0, $4ZSso.jsx)("li", {
                        children: signupLink
                    })
                ]
            })
        ]
    });
};
var $1ef3e311772fd3c0$export$2e2bcd8739ae039 = $1ef3e311772fd3c0$var$WhiteboxFooter;

});

parcelRegister("6KORI", function(module, exports) {

$parcel$export(module.exports, "useGoogleOneTap", function () { return $0514ccbfce379500$export$84fc8ad34c97e462; });

var $91i6m = parcelRequire("91i6m");

var $h6aRF = parcelRequire("h6aRF");

var $fALlm = parcelRequire("fALlm");

var $NAfW5 = parcelRequire("NAfW5");
const $0514ccbfce379500$export$84fc8ad34c97e462 = ({ email: email })=>{
    (0, $h6aRF.useRegisterComponent)($0514ccbfce379500$export$84fc8ad34c97e462.name);
    const { setLoginRecoveryOptions: setLoginRecoveryOptions } = (0, $fALlm.useLoginRecoveryOptionsContext)();
    const buildLoginRecoveryOptions = (0, $NAfW5.useLoginRecoveryOptions)();
    (0, $91i6m.useEffect)(()=>{
        if (!email) return;
        const loginRecoveryOptions = buildLoginRecoveryOptions(email);
        setLoginRecoveryOptions(loginRecoveryOptions);
    }, [
        email,
        setLoginRecoveryOptions,
        buildLoginRecoveryOptions
    ]);
};

});

parcelRegister("7D2jm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $255c740afd9c0353$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

const $255c740afd9c0353$var$BaseRememberedAccountsPage = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("kS3Bd")));
const $255c740afd9c0353$var$RememberedAccountsPage = ()=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)($255c740afd9c0353$var$BaseRememberedAccountsPage, {});
};
var $255c740afd9c0353$export$2e2bcd8739ae039 = $255c740afd9c0353$var$RememberedAccountsPage;

});
parcelRegister("kS3Bd", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("g5rdM")),
    (parcelRequire("ij0b0"))((parcelRequire("lxKym")).resolve("6UgT0"))
]).then(()=>parcelRequire("aAuK0"));

});



parcelRegister("15GiP", function(module, exports) {

$parcel$export(module.exports, "fontFallback", function () { return $0cb7128838712e24$export$2a99220fb32ec798; });
$parcel$export(module.exports, "headingSizes", function () { return $0cb7128838712e24$export$bc02e067df412c3b; });
$parcel$export(module.exports, "h900", function () { return $0cb7128838712e24$export$bdb8f897727a9c67; });
$parcel$export(module.exports, "h800", function () { return $0cb7128838712e24$export$3953fb6fbd158d23; });
$parcel$export(module.exports, "h700", function () { return $0cb7128838712e24$export$e4f993a313607daa; });
$parcel$export(module.exports, "h600", function () { return $0cb7128838712e24$export$1e8b2acea3fb3119; });
$parcel$export(module.exports, "h500", function () { return $0cb7128838712e24$export$85aa43a9b9f06707; });
$parcel$export(module.exports, "h400", function () { return $0cb7128838712e24$export$fcb7764b80bd908f; });
$parcel$export(module.exports, "h300", function () { return $0cb7128838712e24$export$a0e59c3bbc05e815; });
$parcel$export(module.exports, "h200", function () { return $0cb7128838712e24$export$7ccf32eb2150ac7e; });
$parcel$export(module.exports, "h100", function () { return $0cb7128838712e24$export$dfc0e69214efdc3c; });

var $dsN6L = parcelRequire("dsN6L");

var $kLNLK = parcelRequire("kLNLK");

var $6e88g = parcelRequire("6e88g");
function $0cb7128838712e24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0cb7128838712e24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0cb7128838712e24$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0cb7128838712e24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0cb7128838712e24$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $0cb7128838712e24$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $0cb7128838712e24$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $0cb7128838712e24$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h900.size, $0cb7128838712e24$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 6.5, "px")
    });
};
var $0cb7128838712e24$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h800.size, $0cb7128838712e24$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 5, "px")
    });
};
var $0cb7128838712e24$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h700.size, $0cb7128838712e24$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 5, "px")
    });
};
var $0cb7128838712e24$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h600.size, $0cb7128838712e24$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 3.5, "px")
    });
};
var $0cb7128838712e24$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h500.size, $0cb7128838712e24$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 3, "px")
    });
};
var $0cb7128838712e24$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h400.size, $0cb7128838712e24$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};
var $0cb7128838712e24$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h300.size, $0cb7128838712e24$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $0cb7128838712e24$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h200.size, $0cb7128838712e24$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};
var $0cb7128838712e24$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h100.size, $0cb7128838712e24$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};

});

parcelRegister("24QNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1834e80975c961d7$export$2e2bcd8739ae039; });
var $1834e80975c961d7$var$isProduction = true;
var $1834e80975c961d7$var$prefix = "Invariant failed";
function $1834e80975c961d7$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($1834e80975c961d7$var$isProduction) throw new Error($1834e80975c961d7$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($1834e80975c961d7$var$prefix, ": ").concat(provided) : $1834e80975c961d7$var$prefix;
    throw new Error(value);
}

});

parcelRegister("lyJnu", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", function () { return $fb1ff9104554a579$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $fb1ff9104554a579$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_HOME", function () { return $fb1ff9104554a579$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $fb1ff9104554a579$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "KEY_TAB", function () { return $fb1ff9104554a579$export$10f6869ed0a7d75b; });
$parcel$export(module.exports, "KEY_ENTER", function () { return $fb1ff9104554a579$export$8152f929a25a0ff4; });
$parcel$export(module.exports, "KEY_SPACE", function () { return $fb1ff9104554a579$export$e51a3576c045c8d5; });
$parcel$export(module.exports, "ESCAPE", function () { return $fb1ff9104554a579$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $fb1ff9104554a579$export$390330c10ff2b9a1 = "ArrowUp";
var $fb1ff9104554a579$export$a80636c6f41931fe = "ArrowDown";
var $fb1ff9104554a579$export$4af703091671bc = "Home";
var $fb1ff9104554a579$export$e2bc30913faa5db7 = "End";
var $fb1ff9104554a579$export$10f6869ed0a7d75b = "Tab";
var $fb1ff9104554a579$export$8152f929a25a0ff4 = "Enter";
var $fb1ff9104554a579$export$e51a3576c045c8d5 = "Space";
var $fb1ff9104554a579$export$2bb790b9008907b4 = "Escape";

});

parcelRegister("aTAfv", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $7eeb28c052954e83$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $7eeb28c052954e83$export$bb5ca5fba6fb4f1f; });

var $91i6m = parcelRequire("91i6m");

var $kV8TC = parcelRequire("kV8TC");
var $7eeb28c052954e83$var$generateUID = function(context) {
    var quartz = context || (0, $kV8TC.counter);
    var prefix = (0, $kV8TC.getPrefix)(quartz);
    var id = (0, $kV8TC.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $7eeb28c052954e83$var$useUIDState = function() {
    var context = (0, $91i6m.useContext)((0, $kV8TC.source));
    var uid = (0, $91i6m.useState)(function() {
        return $7eeb28c052954e83$var$generateUID(context);
    })[0];
    return uid;
};
var $7eeb28c052954e83$export$87d05f07e65211f1 = function() {
    var uid = $7eeb28c052954e83$var$useUIDState().uid;
    return uid;
};
var $7eeb28c052954e83$export$bb5ca5fba6fb4f1f = function() {
    var gen = $7eeb28c052954e83$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("kV8TC", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $f3b0081445314065$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $f3b0081445314065$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $f3b0081445314065$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $f3b0081445314065$export$36e24695f02d4503; });

var $91i6m = parcelRequire("91i6m");

var $3Bnk9 = parcelRequire("3Bnk9");
var $f3b0081445314065$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $3Bnk9.generateUID)()
    };
};
var $f3b0081445314065$export$e575061ef2a070eb = $f3b0081445314065$export$1921362e86c73c88();
var $f3b0081445314065$export$b4d5da5f34fb77ad = $91i6m.createContext($f3b0081445314065$export$1921362e86c73c88());
var $f3b0081445314065$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $f3b0081445314065$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});



//# sourceMappingURL=BasePage.c4f4a5ed.js.map
